import { Button, Icon, Space } from 'ui';
import { useDirectMessage } from 'features/chat';
import { MemberNavigationButtons } from '../member-navigation-buttons';

type P = {
  member: {
    id: string;
    nodeId?: string;
  };
};

const MemberActions = ({ member: { id, nodeId } }: P) => {
  const { handleDirectMessage, isFetching } = useDirectMessage();

  return (
    <Space block orientation="vertical" size="small">
      <Button
        block
        icon={<Icon icon="comment-line" />}
        loading={isFetching}
        onClick={() => {
          handleDirectMessage({ id });
        }}
        type="primary"
      >
        Send message
      </Button>
      <MemberNavigationButtons memberId={id} nodeUserId={nodeId} />
    </Space>
  );
};

export default MemberActions;
